import React, { Component } from 'react';
import { Dropdown } from 'semantic-ui-react';
import PropTypes from 'prop-types';

export default class BookingSelectList extends Component {
  static propTypes = {
    disabled: PropTypes.bool,
    filterName: PropTypes.string.isRequired,
    headerText: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    options: PropTypes.arrayOf(PropTypes.shape({
      text: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    })).isRequired,
    placeholder: PropTypes.string,
    value: PropTypes.string,
    search: PropTypes.string,
    style: PropTypes.shape({}),
  }
  static defaultProps = {
    hasSearch: false,
    options: [],
    placeholder: 'Select an Option',
    value: '',
  }
  static getPropsToState = (props) => {
    const value = props.value || '';
    const search = props.search || '';
    return {
      value,
      search,
    };
  }
  constructor(props) {
    super(props);
    const state = BookingSelectList.getPropsToState(props);
    this.state = state;
  }
  componentWillReceiveProps(nextProps) {
    const state = BookingSelectList.getPropsToState(nextProps);
    this.setState({ ...state });
  }
  handleOnChange = (e, { value }) => {
    this.setState({ value }, () => {
      this.props.onChange(value, this.props.filterName);
    });
  }
  render() {
    const classNames = ['booking'];
    if (this.state.value.length > 0) {
      classNames.push('selected');
    }
    const options = this.props.options;
    const truncateStyle = {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      display: 'inline-block',
      maxWidth: '100%',
    };
    const hasHeader = options && options.some(opt => opt.header);
    if (hasHeader) {
      options.forEach((opt, idx, arr) => {
        if (opt.header) {
          if (idx > 0 && !arr[idx - 1].divider) {
            options.splice(idx, 0, { divider: true });
          }
        }
      });
      return (
        <Dropdown
          className={classNames.join(' ')}
          disabled={this.props.disabled}
          fluid
          header={this.props.headerText}
          onChange={this.handleOnChange}
          selectOnBlur={false}
          text={this.state.value && options && options.length > 0 ?
            options.find(o => o.value === this.state.value).text
            : null}
          placeholder={this.props.placeholder}
          value={this.state.value}
          scrolling
          style={this.props.style}
        >
          <Dropdown.Menu>
            {
              this.props.headerText && <Dropdown.Header content={this.props.headerText} />
            }
            {
              options && options.length > 0 ?
              options.map((opt, idx) => {
                if (opt.divider) {
                  return (
                    <Dropdown.Divider key={idx} />
                  );
                }
                if (opt.header) {
                  return (
                    <Dropdown.Header key={idx} content={opt.text} />
                  );
                }
                return (
                  <Dropdown.Item
                    key={idx}
                    value={opt.value}
                    text={opt.text}
                    selected={this.state.value === opt.value}
                    onClick={this.handleOnChange}
                  />
                );
              })
              : null
            }
          </Dropdown.Menu>
        </Dropdown>
      );
    }
    return (
      <Dropdown
        className={classNames.join(' ')}
        disabled={this.props.disabled}
        fluid
        header={this.props.headerText}
        onChange={this.handleOnChange}
        options={options}
        selectOnBlur={false}
        placeholder={this.props.placeholder}
        value={this.state.value}
        scrolling
        style={this.props.style}
        search
        text={
          this.state.value
            ? <span style={truncateStyle}>{options.find(o => o.value === this.state.value).text}</span>
            : this.props.placeholder
        }
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Filters/BookingSelectList.jsx